import Vue from 'vue'
import VueRouter from 'vue-router'
import AuthService from '../services/authService'

import Login from '../views/Login.vue'
import AuthCallback from '../views/AuthCallback.vue'
import Dashboard from '../views/Dashboard.vue'

import Search from '../components/TestSearchWidget.vue'
import SearchResults from '../views/Tests/SearchResults.vue'
import TestDetails from '../views/Tests/TestDetails.vue'
import StationIndex from '../views/Stations/StationIndex.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    component: Login,
    meta: { 
      allowAnonymous: true
    }
  },
  {
    path: '/authcallback',
    component: AuthCallback,
    meta: { 
      allowAnonymous: true
    }
  },
  {
    path: '/',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      breadcrumbs: [ 'Dashboard' ]
    }
  },
  {
    path: '/search',
    name: 'search-tests',
    component: Search,
    meta: {
      breadcrumbs: [ 'Vehicle Search' ]
    }
  },
  {
    path: '/search/results/:searchTermProp',
    name: 'search-test-results',
    component: SearchResults,
    props: true,
    meta: {
      breadcrumbs: [ 'Vehicle Search', 'Results' ]
    }
  },
  {
    path: '/tests/:testId',
    name: 'test-details',
    component: TestDetails,
    props: true,
    meta: {
      breadcrumbs: [ 'Test Details' ]
    }
  },
  {
    path: '/stations',
    name: 'station-index',
    component: StationIndex,
    meta: {
      breadcrumbs: [ 'Test Stations' ]
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

const authService = new AuthService()
router.beforeEach((to, from, next) => {
  if (to.meta.allowAnonymous || authService.isLoggedIn()) {
    next()
  }
  else {
    next({ path: '/login', query: { redirect: to.fullPath } })
  }
})

export default router
